import React from 'react';
import { Tooltip } from 'antd';

/**
 * Shared UX for Deploy actions blocked because another version of the task is
 * already deployed (only one version can be deployed per task at a time).
 * Used by the Models page row menu, the Homepage task menus (Card + List
 * views), and the Model Details drawer.
 */

/**
 * Dropdown menus (and their submenus) get elevated z-indexes from antd's
 * contextual z-index management, which can end up above a Tooltip's default
 * layer (1070) — hiding the tooltip behind the menu. Render these tooltips
 * above every popup chain in the app (drawers 2000, modals 2100, floating
 * progress bar 2200/2300).
 */
export const BLOCKED_DEPLOY_TOOLTIP_Z_INDEX = 3000;

/** Tooltip copy explaining why Deploy is blocked. */
export function undeployFirstTooltip(deployedVersionLabel) {
  const label = deployedVersionLabel || 'another version';
  return (
    `${label} is currently deployed. Only one version can be deployed per ` +
    `task - undeploy ${label} first, then deploy this version.`
  );
}

/**
 * Label for a disabled Deploy menu item, wrapped with the explanatory
 * tooltip. Ant Design keeps mouse events on disabled menu items, so the
 * tooltip still shows on hover.
 */
export function blockedDeployMenuLabel(labelText, deployedVersionLabel) {
  return (
    <Tooltip
      title={undeployFirstTooltip(deployedVersionLabel)}
      placement="left"
      zIndex={BLOCKED_DEPLOY_TOOLTIP_Z_INDEX}
    >
      <span className="fs-unmask">{labelText}</span>
    </Tooltip>
  );
}

/** Tooltip copy explaining why Move Task is blocked for a deployed task. */
export const MOVE_LOCKED_TOOLTIP =
  'This task is deployed and can’t be moved. Undeploy it first, then move it to another project.';

/**
 * Label for a disabled Move Task menu item, wrapped with the explanatory
 * tooltip (same hover behaviour as `blockedDeployMenuLabel`).
 */
export function blockedMoveMenuLabel(labelText) {
  return (
    <Tooltip
      title={MOVE_LOCKED_TOOLTIP}
      placement="left"
      zIndex={BLOCKED_DEPLOY_TOOLTIP_Z_INDEX}
    >
      <span className="fs-unmask">{labelText}</span>
    </Tooltip>
  );
}
